import { Copy, EyeIcon, FileAxis3D, FileTerminal, Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { email } from "zod";
import { GetPartnerReport } from "../../services/partner/partner";
import { showErrorToast, showInfoToast } from "../../utils/toastUtils";
import EditPage from "./updatePartner";

function PartnerReport() {
  const [reportData, setReportData] = useState(null);
  const [isCopied, setIsCopied] = useState({});
  const [searchByPartnerId, setSearchByPartnerId] = useState("");
  const [searchByMobile, setSearchByMobile] = useState("");
  const [searchByEmail, setSearchByEmail] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [activeTab, setActiveTab] = useState("PNT");
  const [searchByMobileEnt, setSearchByMobileEnt] = useState("");
  const [searchByEmailEnt, setSearchByEmailEnt] = useState("");

  const [loading, setLoading] = useState(false);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);

    setIsCopied((prev) => ({
      ...prev,
      [index]: true,
    }));
  };
  const handlePartnerReport = async () => {
    const payload = {};

    if (searchByPartnerId) payload.partner_id = searchByPartnerId;
    if (searchByEmail) payload.email = searchByEmail;
    if (searchByMobile) payload.mobile = searchByMobile;
    if (searchByEmailEnt) payload.email_original = searchByEmailEnt;
    if (searchByMobileEnt) payload.mobile_original = searchByMobileEnt;
    if (fromDate) payload.from_date = fromDate;
    if (toDate) payload.to_date = toDate;
    if (perPage) payload.limit = perPage;
    payload.page = currentPage;
    setLoading(true);

    try {
      const res = await GetPartnerReport(payload);

      if (res?.status?.code === 200) {
        setReportData(res?.data);
      } else {
        showErrorToast(res?.data?.message || res?.data?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setSearchByPartnerId("");
      setSearchByMobile("");
      setSearchByEmail("");
      setSearchByMobileEnt("");
      setSearchByEmailEnt("");
      setFromDate("");
      setToDate("");
      setPerPage(10);
    }
  };

  useEffect(() => {
    handlePartnerReport();
  }, [currentPage]);


const leadPartners =
  reportData?.partners?.filter(
    (item) => item.is_partner_exist === 0
  ) || [];

const originalPartners =
  reportData?.partners?.filter(
    (item) => item.is_partner_exist === 1
  ) || [];


  return (
    <div className="min-h-screen pt-4 px-4 md:px-6 lg:px-8 space-y-4 bg-white text-black">
      <div className="text-4xl font-extrabold   text-blue-700 flex items-center gap-3">
        <FileAxis3D size={34} className="text-blue-700" />
        Partner Report
      </div>

      <div className="space-y-8">

        <div className="bg-white rounded-xl shadow-sm ">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">

            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                From Date
              </label>
              <input
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="px-3 py-2  border-gray-800 text-sm border  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                type="date"
                name=""
                id=""
              />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                To Date
              </label>
              <input
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="px-3 py-2  border-gray-800 text-sm border  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                type="date"
                name=""
                id=""
              />
            </div>

            {/* Search by Id*/}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                Search by Partner ID
              </label>
              <input
                value={searchByPartnerId}
                type="search"
                placeholder="Eg. ENT0004 / PNT0004"
                onChange={(e) => setSearchByPartnerId(e.target.value)}
                className="px-3 py-2  border-gray-800 text-sm border  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>


            {activeTab === "PNT" && (

              <>
                {/* email ID */}
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-medium text-gray-600">
                    Search By Email ID
                  </label>
                  <input
                    type="search"
                    value={searchByEmail}
                    onChange={(e) => setSearchByEmail(e.target.value)}
                    placeholder="Eg. abc@gmail.com"
                    className="px-3 py-2 text-sm border border-gray-800  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                {/* mobile*/}
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-medium text-gray-600">
                    Search By Mobile No.
                  </label>
                  <input
                    type="search"
                    value={searchByMobile}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setSearchByMobile(value);
                    }}
                    placeholder="Eg. 8569875489"
                    className="px-3 py-2 text-sm border border-gray-800 uppercase rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </>

            )}

            {activeTab === "ENT" && (
              <>


                {/* email ID */}
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-medium text-gray-600">
                    Search By Email ID
                  </label>
                  <input
                    type="search"
                    value={searchByEmailEnt}
                    onChange={(e) => setSearchByEmailEnt(e.target.value)}
                    placeholder="Eg. abc@gmail.com"
                    className="px-3 py-2 text-sm border border-gray-800  rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                {/* mobile*/}
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-medium text-gray-600">
                    Search By Mobile No.
                  </label>
                  <input
                    type="search"
                    value={searchByMobileEnt}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setSearchByMobileEnt(value);
                    }}
                    placeholder="Eg. 8569875489"
                    className="px-3 py-2 text-sm border border-gray-800 uppercase rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

              </>
            )}


            {/* Per Page */}
            <div className="flex flex-col gap-1">
              <label className="text-xs font-medium text-gray-600">
                Per Page
              </label>
              <select
                value={perPage}
                onChange={(e) => setPerPage(e.target.value)}
                className="px-3 py-2 text-sm border border-gray-800 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-4 justify-left mt-12">
        <button
          onClick={() => setActiveTab("PNT")}
          className={`px-4 py-2 rounded ${activeTab === "PNT"
            ? "bg-blue-600 text-white"
            : "bg-gray-200 text-black"
            }`}
        >
          Partner Lead Report
        </button>

        <button
          onClick={() => setActiveTab("ENT")}
          className={`px-4 py-2 rounded ${activeTab === "ENT"
            ? "bg-blue-600 text-white"
            : "bg-gray-200 text-black"
            }`}
        >
          Registered Partner Report
        </button>

        <button
          onClick={handlePartnerReport}
          className="bg-blue-500 hover:bg-green-600 text-white px-5 py-2 rounded-md disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-3"
        >
          <FileTerminal />
          Get Report
        </button>

      </div>

      {reportData?.partners?.length > 0 && (
        <>
          {activeTab === "PNT" && (
            <RenderTable
              title="Partner Lead Report"
              data={leadPartners}
              setSelectedRow={setSelectedRow}
              type="PNT"
            />
          )}

          {activeTab === "ENT" && (
            <RenderTable
              title="Registered Partner Report "
              data={originalPartners}
              setSelectedRow={setSelectedRow}
              type="ENT"
            />
          )}
        </>
      )}



      <EditPage
        data={selectedRow}
        onClose={() => setSelectedRow(null)}
        activeTab={activeTab}
      />
    </div>
  );
}


const RenderTable = ({ title, data, setSelectedRow, type }) => (
  <div className="mt-8">
    <h2 className="text-xl font-bold text-blue-700 mb-3">{title}</h2>

    <div className="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
      <table className="min-w-[700px] w-full text-xs text-left text-gray-700">
        <thead className="bg-gradient-to-r from-cyan-600 to-blue-600 text-gray-100 uppercase">
          <tr>
            <th className="px-4 py-3">Partner ID</th>

            {type === "PNT" && (
              <>
                <th className="px-4 py-3">Mobile</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Company Domain</th>

              </>
            )}

            {type === "ENT" && (
              <>
                <th className="px-4 py-3">Mobile</th>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Partner Domain</th>
                <th className="px-4 py-3">Google Captcha Key</th>
                <th className="px-4 py-3">Company Name</th>
                <th className="px-4 py-3">Brand Name</th>
                <th className="px-4 py-3">Support Mail Id</th>
                <th className="px-4 py-3">WhatsApp Number</th>
                <th className="px-4 py-3">Calling Number</th>
                <th className="px-4 py-3">Logo</th>

              </>
            )}
            <th className="px-4 py-3">Referred By</th>
            <th className="px-4 py-3">Created At</th>
            <th className="px-4 py-3">Edit</th>
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.user_id}>
                <td className="px-4 py-3">{item.partner_id || "-"}</td>
                {type === "PNT" && (
                  <>
                    <td className="px-4 py-3">{item.mobile_number || "-"}</td>
                    <td className="px-4 py-3">{item.email_address || "-"}</td>
                    <td className="px-4 py-3">{item.company_domain || "-"}</td>
                  </>
                )}

                {type === "ENT" && (
                  <>
                    <td className="px-4 py-3">{item.mobile_number_original || "-"}</td>
                    <td className="px-4 py-3">{item.email_id_original || "-"}</td>
                    <td>{item.partner_domain || "-"}</td>
                    <td>{item.google_captcha_key || "-"}</td>
                    <td className="px-4 py-3">{item.company_name || "-"}</td>
                    <td className="px-4 py-3">{item.brand_name || "-"}</td>
                    <td className="px-4 py-3">{item.support_mail_id || "-"}</td>
                    <td className="px-4 py-3">{item.whatsapp_number || "-"}</td>
                    <td className="px-4 py-3">{item.calling_number || "-"}</td>
                    <td className="px-4 py-3">{item.logo || "-"}</td>
                  </>
                )}
                <td className="px-4 py-3">{item.referred_by || "-"}</td>

                <td className="px-4 py-3">
                  {new Date(item.created_at).toLocaleString()}
                </td>
                <td>
                  <button
                    onClick={() => setSelectedRow(item)}
                    className="bg-blue-500 text-white px-2 py-1 rounded"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center py-4">
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default PartnerReport;
